// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3dTdY","container":"styles_container__2nYLk","title":"styles_title__1zdNF","wrapper":"styles_wrapper__90NHD","answer":"styles_answer__rrrNP"};